var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon /  filter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-/--filter",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter_new_copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9570676,6.33236858 C17.8718449,6.13635634 17.6758327,6 17.4542536,6 L6.54574638,6 C6.32416733,6 6.12815509,6.13635634 6.04293238,6.33236858 C5.95770966,6.53690309 6.00032102,6.77552669 6.16224417,6.92892757 L10.3637239,11.1304073 L10.3637239,15.2722312 C10.3637239,15.4171098 10.4233798,15.5534661 10.5256471,15.6557334 L12.7073485,17.8374348 C12.8096158,17.9482243 12.9459721,17.999358 13.0908507,17.999358 C13.1590289,17.999358 13.2357293,17.9823134 13.3039075,17.9567466 C13.4999197,17.8715239 13.6362761,17.6755117 13.6362761,17.4539326 L13.6362761,11.1304073 L17.8377558,6.92892757 C17.999679,6.77552669 18.0422903,6.53690309 17.9570676,6.33236858 L17.9570676,6.33236858 Z",
    id: "filter---FontAwesome",
    fill: "#FFFFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.b38c941951a93d7596ec6d7325b8fb03.svg";
export { ForwardRef as ReactComponent };